module.exports = __webpack_public_path__ + "img/2541d233def8b6dcc3027dea7a08dff0.png";